import { useParams, useSearchParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import { useCheckAndConfirmStripe } from '../../payment/PaymentInformation'
import { StripeElementsContainer } from '@jotta/settings/StripeContainer'
import { useStripe } from '@stripe/react-stripe-js'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'
import { Redirect } from '@jotta/ui/Redirect'
import { AuthTransportProvider } from '@jotta/grpc-connect-client/provider'
import { base64UrlSafeToBytes } from '@jotta/utils/base64'
import { ClientState } from '@jotta/grpc-connect-openapi/clientstate'

function CheckAndConfirmPaypal({
  orderNumber,
  successPath,
  failurePath,
}: {
  orderNumber: string
  successPath: string
  failurePath: string
}) {
  const stripe = useStripe()
  const checkAndConfirm = useCheckAndConfirmStripe(successPath)

  const { isPending } = useQuery({
    throwOnError: false,
    enabled: Boolean(stripe),
    queryKey: ['checkAndConfirmPayPal'],
    queryFn: () => stripe && checkAndConfirm(stripe, orderNumber),
  })

  if (isPending) {
    return <LoadingOverlay open />
  }

  return <Redirect to={failurePath} />
}

export function PayPalPaymentRoute() {
  const { orderNumber } = useParams()
  const [searchParams] = useSearchParams()
  const stateBytesBase64 = searchParams.get('state')

  if (!orderNumber || !stateBytesBase64) {
    return <Redirect to="/" />
  }

  const clientState = ClientState.fromBinary(
    base64UrlSafeToBytes(stateBytesBase64),
  )

  return (
    <AuthTransportProvider>
      <StripeElementsContainer>
        <CheckAndConfirmPaypal
          orderNumber={orderNumber}
          successPath={clientState.successPath}
          failurePath={clientState.failurePath}
        />
      </StripeElementsContainer>
    </AuthTransportProvider>
  )
}
